"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const React = require("react");
const theme_1 = require("../modules/theme");
const react_native_1 = require("react-native");
class Link extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                link: {
                    fontFamily: theme.fontFamily2,
                    fontSize: 14,
                    color: theme.textColor2
                }
            });
            return styles;
        };
    }
    render() {
        const { text, style, onPress } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.7, onPress: onPress },
            React.createElement(react_native_1.Text, { style: [styles.link, style] }, text)));
    }
}
exports.Link = Link;
